export const fallbackTestimonials = [
  {
    quote: 'Dankamf Eduplex has been a second home for my children. The teachers are caring and the environment is perfect for learning.',
    name: 'Mrs. Ama Serwaa',
    role: 'Parent',
  },
  {
    quote: 'I love my school! We learn so much and have a lot of fun with sports and other activities.',
    name: 'David Mensah',
    role: 'Grade 5 Student',
  },
  {
    quote: 'The commitment to academic excellence and moral values at Dankamf Eduplex is truly impressive.',
    name: 'Mr. John Ofori',
    role: 'Parent',
  },
  {
    quote: 'The modern facilities and dedicated staff create an outstanding learning atmosphere for students.',
    name: 'Dr. Evelyn Adu',
    role: 'Board Member',
  },
];
